import { useMemo } from "react";
import { MEDIA_TASK_TYPE_NAMES } from "../constants/TaskTypeNames";
import { useAllTaskTypes } from "./useTaskTypes";

/**
 * Resolves the task-type IDs for media maintenance task types
 * (MEDIA_TASK_TYPE_NAMES), for use with v2 task endpoints that take
 * task_type_ids.
 */
export const useMediaTaskTypeIds = (): string[] => {
  const { data: taskTypes = [] } = useAllTaskTypes();
  return useMemo(
    () =>
      taskTypes
        .filter((tt) =>
          (MEDIA_TASK_TYPE_NAMES as readonly string[]).includes(tt.name)
        )
        .map((tt) => tt.id),
    [taskTypes]
  );
};
